import * as React from 'react'
import { ResultsCl, TableHeader } from "../../../components/results-table-cl"
import { Ismag } from "../../../openapi/ismag"
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { RootReducer } from "../../../components/app/reducer"

const IsmagResults: React.FC = () => {
    const headerData: TableHeader<Ismag> = { issuerName: "Issuer Name", ctry: "ISO Ctry Code", adherence: "ISMAG Adherence" }
    const rootDispatch = useDispatch()
    const issuers = useSelector((state: RootReducer) => state.ismagReducer.ismagIssuers)
    const searchCriteria = useSelector((state: RootReducer) => state.ismagReducer.ismagSearchCriteria);
    const numberOfIssuers: number = useSelector((state: RootReducer) => state.ismagReducer.ismagIssuers?.length) || 0;
    const numberOfRows: number  = issuers && issuers.length > 0 ? issuers[0].nbrOfRows || 0 : 0;

    useEffect(() => {
        // avoid re-render, do only clean-up
        return () => { rootDispatch({ type: "Ismag/RESETSEARCH" }) }
    }
    , [rootDispatch]) // empty array to signalize this is to be done on render and unmount only

    return (
        <div>            
            <Link to="/ismag">Back to Search Criteria</Link>                            
            <p className="codelist-header">Search for Ismag Adherence Results</p>
            <div>
                <div>
                    Your query returned the	following results.
				</div>
            </div>
            <div>
                {numberOfIssuers === 1 ? <span> <span className="bold"> 1 </span> Issuer found. </span>
                                       : <span> <span className="bold"> {numberOfRows} </span> Issuers found.</span>

                }            
                {numberOfRows > 1000 ? <span> Only <span className="bold"> 1000 </span> displayed. Use download facility to get the complete list.</span> : ""}
            </div>
            <ResultsCl recordsOnPage={100} header={headerData} data={issuers} searchCriteria={searchCriteria}
                urlCSV="/codelist/v1/ISMAG/export/csv"
                urlXML="/codelist/v1/ISMAG/export/xml" />
        </div>
    )
}

export default IsmagResults